var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataset = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M28.733 8H11.267A3.267 3.267 0 0 0 8 11.267v17.466A3.267 3.267 0 0 0 11.267 32h17.466A3.267 3.267 0 0 0 32 28.733V11.267A3.267 3.267 0 0 0 28.733 8m-12 8.733h13.08v5.454h-13.08V16.72zm-2.2 5.454h-4.346V16.72h4.346zm-4.36 6.533v-4.36h4.36v5.467h-3.266a1.093 1.093 0 0 1-1.08-1.094zm18.534 1.093h-12V24.36H29.8v4.373a1.094 1.094 0 0 1-1.08 1.08z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dataset.c5730d1b.svg";